module.exports = __webpack_public_path__ + "img/logo-wsp-white.8516a51c.svg";